<template>
    <el-container>
        <el-header style="margin-top: 20px">
            <!--主页面标签页-->
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane :label="$t('pgCommon.ALARM_USER_SEND_CONFIG')" name="first">
                    <alarm-user-send></alarm-user-send>
                </el-tab-pane>
                <el-tab-pane :label="$t('pgCommon.ALARM_ROLE_SEND_CONFIG')" name="second">
                    <alarm-role-send></alarm-role-send>
                </el-tab-pane>
            </el-tabs>
        </el-header>
    </el-container>
</template>
<script>
import alarmUserSendConfig from './alarmUserSendConfig.vue';
import alarmRoleSendConfig from './alarmRoleSendConfig.vue';
export default {
    created() {},
    components: {
        'alarm-user-send': alarmUserSendConfig,
        'alarm-role-send': alarmRoleSendConfig
    },
    data() {
        return {
            activeName: 'first'
        };
    },
    methods: {}
};
</script>
